module.exports = __webpack_public_path__ + "img/roots.080a5c7c.jpg";